import React, { useEffect, useState } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { useTranslation } from "react-i18next";
import { Button } from "antd";
import axios from "axios";
import jwtDecode from "jwt-decode";
import { Loading } from "../../components/loading";
import { User } from "../../types/user";
import { setUser } from "../actions";
import styles from "./signedIn.module.css";

export const SignedIn = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { t } = useTranslation("signedIn");

  useEffect(() => {
    fetchTokens();
    /*eslint-disable react-hooks/exhaustive-deps*/
  }, []);

  const fetchTokens = () => {
    const code = searchParams.get("code");
    const sessionState = searchParams.get("session_state");

    setIsLoading(true);

    axios
      .get(`${process.env.REACT_APP_API_URL}/Identity/external/microsoft/signedIn`, {
        params: {
          code,
          session_state: sessionState,
          redirect_url: `${window.location.origin}/signedIn`,
        },
      })
      .then((res) => {
        localStorage.setItem("accessToken", res.data.accessToken);
        localStorage.setItem("refreshToken", res.data.refreshToken.refreshToken);

        const user: User = jwtDecode(res.data.accessToken);
        user.role = user["http://schemas.microsoft.com/ws/2008/06/identity/claims/role"];
        user.permissions = user.Permission;
        dispatch(setUser(user));

        navigate("/tenants");
      })
      .catch((err) => {
        console.error(err);
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleTryAgain = () => {
    fetchTokens();
  };

  const handleGoToLogin = () => {
    navigate("/login");
  };

  return (
    <div className={styles.container}>
      {isLoading ? (
        <Loading />
      ) : (
        <div>
          <p className={styles.errorHeader}>{t("someErrorOccurred")}</p>
          <div className={styles.buttonContainer}>
            <Button onClick={handleTryAgain}>{t("tryAgain")}</Button>
            <Button onClick={handleGoToLogin}>{t("goToLogin")}</Button>
          </div>
        </div>
      )}
    </div>
  );
};
